define('org/forgerock/openam/ui/common/util/uri/query',["exports", "lodash", "org/forgerock/commons/ui/common/util/URIUtils"], function (exports, _lodash, _URIUtils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.parseParameters = parseParameters;
  exports.getCurrentQueryParameters = getCurrentQueryParameters;
  exports.urlParamsFromObject = urlParamsFromObject;

  var _lodash2 = _interopRequireDefault(_lodash);

  var _URIUtils2 = _interopRequireDefault(_URIUtils);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * @description Creates an object of key value pairs from the passed in query string
   * @param {String} paramString A string containing a query string
   * @returns {Object} An Object of key value pairs
   */
  /*
   * Copyright 2016-2017 ForgeRock AS. All Rights Reserved
   *
   * Use of this code requires a commercial software license with ForgeRock AS.
   * or with one of its affiliates. All use shall be exclusively subject
   * to such license between the licensee and ForgeRock AS.
   */

  /**
   * @module org/forgerock/openam/ui/common/util/uri/query
   */
  function parseParameters(paramString) {
    var object = _lodash2.default.isEmpty(paramString) ? {} : _lodash2.default.object(_lodash2.default.map(paramString.split("&"), function (pair) {
      var key = pair.substring(0, pair.indexOf("="));
      var value = pair.substring(pair.indexOf("=") + 1);
      return [key, value];
    }));
    return object;
  }

  /**
   * @description Creates an object of key value pairs from the current url query
   * @returns {Object} An Object of key value pairs from the current url query
   */
  function getCurrentQueryParameters() {
    return this.parseParameters(_URIUtils2.default.getCurrentQueryString());
  }

  /**
   * @description Creates query string from an object of key value pairs
   * @param {Object} paramsObject An object of key value pairs
   * @returns {String} A query string.
   */
  function urlParamsFromObject(paramsObject) {
    if (_lodash2.default.isEmpty(paramsObject)) {
      return "";
    }
    return _lodash2.default.map(paramsObject, function (value, key) {
      return key + "=" + value;
    }).join("&");
  }
});

